import { useQuery } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { bonusAdminBody } from "./bonusAdminBody";
import type { CampaignOut } from "../../components/Promotions/DynamicBonuses/types";

type StoredToken = { AccessToken?: string };

async function fetchCampaign(campaignId: string): Promise<CampaignOut> {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);
  const url = API_ROUTES.GET_DYNAMIC_BONUS_CAMPAIGN.replace("{campaign_id}", campaignId);
  const response = await instance.get(url);
  const campaign = bonusAdminBody<CampaignOut>(response);
  if (!campaign) {
    throw new Error("Campaign not found");
  }
  return campaign;
}

export const getCampaignQueryKey = (campaignId: string) =>
  ["GET_DYNAMIC_BONUS_CAMPAIGN", campaignId] as const;

export const useGetCampaign = (campaignId: string) => {
  return useQuery<CampaignOut>({
    queryKey: getCampaignQueryKey(campaignId),
    queryFn: () => fetchCampaign(campaignId),
    enabled: Boolean(campaignId),
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};
